import { combineReducers } from "redux";
import mainSlice from "./slices/main";
import addressSlice from "./slices/address/address";
import basketSlice from "./slices/basket/basket";
import userSlice from "./slices/user";
import productSlice from "./slices/selection";
import otpSlice from "./slices/otp";
export const reducers = combineReducers({
    mainState: mainSlice,
    addressState: addressSlice,
    userState: userSlice,
    basketState: basketSlice,
    selectionState: productSlice,
    otpState: otpSlice,
});
